<template>
  <div class="pt-2 text-center text-secondary">
    <span v-if="isWeekend() && activeDay()">
      {{ getDayNumber() }}
    </span>
    <span
      v-if="!isWeekend() && activeDay() && !displayDay() && !selectedDay() && getDayNumber()"
      class="chooseday cursor-pointer bg-secondary text-white rounded-circle"
      style="width:40px;height:40px;padding-top:8px;"
      @click="showDay('empty')"
    >
      {{ getDayNumber() }}
    </span>
    <span
      v-if="selectedDay() && activeDay() && getDayNumber()"
      class="cursor-pointer bg-light border rounded-circle"
      style="width:40px;height:40px;padding-top:8px;"
    >
      {{ getDayNumber() }}
    </span>
    <span
      v-if="activeDay() && displayDay() && getDayNumber()"
      class="chooseday cursor-pointer bg-primary text-white rounded-circle"
      style="width:40px;height:40px;padding-top:8px;"
      @click="showDay(getDayNumber())"
    >
      {{ getDayNumber() }}
    </span>
    <span
      v-if="!activeDay() && getDayNumber()"
      style="width:40px;height:40px;padding-top:8px;"
    >
      {{ getDayNumber() }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    calendar: Object,
    nodays: Number,
    i: Number,
    day: {
      default: false,
    },
  },
  methods: {
    selectedDay() {
      return this.day == this.i + 1 - this.nodays && this.day;
    },
    isWeekend() {
      const numeroDia = this.i;
      const matrizDias = [0, 1, 2, 3, 4, 5, 6, 0, 1, 2, 3, 4, 5, 6, 0, 1, 2, 3, 4, 5, 6, 0, 1, 2, 3, 4, 5, 6, 0, 1, 2, 3, 4, 5, 6];
      const diaDeLaSemana = matrizDias[numeroDia];
      return diaDeLaSemana === 5 || diaDeLaSemana === 6;
    },
    getDayNumber() {
      const day = this.i + 1 - this.nodays;
      if (day < 1 || day > this.getDaysInMonth(this.calendar.currentyear, this.calendar.currentmonth)) {
        return "";
      }
      return day;
    },
    getDaysInMonth(year, month) {
      return new Date(year, month, 0).getDate();
    },
   activeDay() {
      const day = this.i + 1 - this.nodays;
      if (day < 1) {
        return false;
      }
      const fechaActual = new Date();
      const fechaSeleccionada = new Date(this.calendar.currentyear, this.calendar.currentmonth - 1, day);
      return fechaSeleccionada >= fechaActual;
    },
    displayDay() {
      return this.calendar.days[this.i] == 2 && this.day != (this.i + 1 - this.nodays);
    },
    showDay(day) {
      this.$emit('showDay', day);
    },
  },
};
</script>

<style scoped>
.chooseday:hover {
  border: 1px solid #6c757d !important;
  background: white !important;
  color: #6c757d !important;
}
</style>